import React from 'react';
import { SectionHeader } from '../onyx/SectionHeader';

/**
 * Lightweight grouping wrapper for the member dashboard.
 * Wireframe-inspired sections mapped onto real product flows — not a task engine.
 */
export function DashboardGroup({
  title = null,
  description = null,
  children,
  testId,
}) {
  if (!children) {
    return null;
  }

  const items = React.Children.toArray(children).filter(Boolean);
  if (items.length === 0) {
    return null;
  }

  return (
    <section className="dashboard-group" data-testid={testId || undefined}>
      {title ? <SectionHeader title={title} description={description} /> : null}
      <div className="dashboard-group__body">{items}</div>
    </section>
  );
}

export default DashboardGroup;
